import React, { useState } from 'react';

import { IntegrationSlot } from '../../integrations-list/integration-slot';
import { getIntegrationSubtitle } from '../../integrations-utils';
import { ModalComponent } from './modal-component';
import { ModalIntegrationProps } from './modal-strategy.types';

type Props = {
    isIntegrated?: boolean
} & ModalIntegrationProps;

export const ModalStrategyComponent = ({
    isIntegrated = false,
    testId,
    modal,
    subtitle,
    ...props
}: Props) => {
    const [isModalOpened, setModalOpened] = useState(false);
    return (
        <>
            <IntegrationSlot
                {...props}
                isDisabled={false}
                isIntegrated={isIntegrated}
                subtitle={subtitle || getIntegrationSubtitle({ isDisabled: false, isIntegrated })}
                onClick={() => {
                    setModalOpened(true);
                }}
                testId={testId}
            />

            <ModalComponent
                onClose={() => setModalOpened(false)}
                isOpen={isModalOpened}
                {...modal}
            />
        </>
    );
};
